import { TMetadata } from '@core/interfaces/TMetadata';

export const createSlug = (input: string): string => {
  return input.replace(/[^\w\s]/g, '').trim().replace(/\s+/g, '_').toLowerCase();
};

export const isSlugCreatedInMetadata = (slug: string, collection: TMetadata[]): boolean => {
  return collection.some((item) => item.slug === slug);
};
